<template>
  <el-form-item :label="f.label">
    <el-input v-if="f.type == 'text'" v-model="f.value" type="text" :name="f.field" :id="f.field"></el-input>

    <el-input-number
      v-else-if="f.type == 'number'"
      v-model="f.value"
      controls-position="right"
      :name="f.field"
    ></el-input-number>

    <select
      v-else-if="f.type == 'select'"
      v-model="f.value"
      :placeholder="f.label"
      :name="f.field"
      class="select"
    >
      <option v-for="(item, i) in f.options" :key="i" :value="item.id">{{item.key}}</option>
    </select>

    <el-select
      v-else-if="f.type == 'select_multiple'"
      v-model="f.value"
      :placeholder="f.label"
      multiple
      :name="f.field"
      class="select"
    >
      <el-option v-for="item in f.options" :key="item.id" :value="item.id" :label="item[f.key]"></el-option>
    </el-select>

    <el-date-picker
      v-else-if="f.type == 'date'"
      v-model="f.value"
      :placeholder="f.label"
      :name="f.field"
      :picker-options="pickerOptions1"
      format="dd/MM/yyyy"
    ></el-date-picker>

    <el-switch
      v-else-if="f.type == 'switch'"
      v-model="f.value"
      :placeholder="f.label"
      :active-value="'1'"
      :inactive-value="'2'"
    ></el-switch>

    <el-checkbox-group v-else-if="f.type == 'checkbox'" v-model="f.value" :name="f.field">
      <el-checkbox border v-for="(item, i) in f.options" :key="i" :label="item.id">{{item.key}}</el-checkbox>
    </el-checkbox-group>

    <el-radio-group v-else-if="f.type == 'radio'" v-model="f.value" :name="f.field">
      <el-radio border v-for="(item, i) in f.options" :key="i" :label="item.id">{{item.key}}</el-radio>
    </el-radio-group>

    <el-input v-else-if="f.type == 'textarea'" v-model="f.value" type="textarea" :name="f.field"></el-input>

    <el-color-picker v-else-if="f.type == 'color'" v-model="f.value" :name="f.field"></el-color-picker>

    <div v-else-if="f.type == 'image'">
      <input type="text" class="hidden" :id="f.field" :name="f.field" :value="f.value" />
      <app-cropper :options="options"></app-cropper>
    </div>
    <div v-else-if="f.type == 'file'">
      <el-upload
        ref="file"
        action
        :auto-upload="false"
        :multiple="false"
        :on-remove="handleRemove"
        :on-change="handleChange"
        :on-preview="handlePreview"
        :file-list="documento"
        :limit="1"
      >
        <el-button size="small" type="primary">Clic para cargar archivo</el-button>
      </el-upload>
    </div>

    <vue-editor
      v-else-if="f.type == 'texto_enriquecido'"
      v-model="f.value"
      :editorToolbar="customToolbar"
    ></vue-editor>
  </el-form-item>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import { API_UPLOADS } from "@/common/config";

export default {
  name: "itemsForm",
  props: ["f"],
  components: {
    VueEditor,
    "app-cropper": Cropper
  },
  created() {
    this.f.value
      ? (this.documento = [
          {
            file: this.folder + this.f.value,
            url: this.folder + this.f.value,
            name: this.f.value
          }
        ])
      : false;
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "formula"],
        [{ direction: "rtl" }]
      ],
      documento: [
        {
          file: null
        }
      ],
      folder: API_UPLOADS,
      pickerOptions1: {
        firstDayOfWeek: 1
      }
    };
  },
  methods: {
    handleRemove(file) {
      this.documento = [];
      this.$root.$emit("load-doc", this.documento);
    },
    handleChange(file) {
      this.documento = [file];
      this.$root.$emit("load-doc", this.documento);
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/itemsForm.vue